<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <h1 class="my-3">{{title}}</h1>
      <v-layout row>
        <v-flex xs12 lg8 md8 v-if="$store.getters.user !== null">
          <v-layout row v-if="$store.getters.user.sale_group === null">
            <v-flex xs4 lg4 md4 v-if="$store.getters.user.branch === null">
              <v-select
                  :items="branchTitleList"
                  label="Филиалы"
                  v-model="branch"
                  class="mr-3"
                  @input="onBranchSelect()"
                  outline
                  no-data-text="Нет данных"
              ></v-select>
            </v-flex>

            <v-flex xs4 lg4 md4 v-if="branch !== 'Все филиалы' && branch !== null">
              <v-select
                  :items="saleGroupTitleList"
                  label="Супервайзер"
                  v-model="saleGroup"
                  class="mr-3"
                  @input="onSaleGroupSelect()"
                  outline
                  no-data-text="Нет данных"
              ></v-select>
            </v-flex>

            <v-flex xs4 lg4 md4>
              <v-select
                  :items="userGroupTitleList"
                  label="Группа пользователей"
                  v-model="userGroup"
                  class="mr-0"
                  @input="onUserGroupSelect()"
                  outline
                  no-data-text="Нет данных"
              ></v-select>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Заголовок"
              v-model="notificationTitle"
              :rules="notificationTitleRules"
              validate-on-blur
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg8 md8>
          <v-textarea
              outline
              name="input-7-4"
              label="Текст сообщения"
              rows="10"
              value=""
              v-model="description"
              :rules="descriptionRules"
              validate-on-blur
          ></v-textarea>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg8 md8>
          <v-radio-group v-model="notificationType" row>
            <v-radio label="Текстовое сообщение" value="1"></v-radio>
            <v-radio label="Текстовое сообщение с вариантами ответов" value="2"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <v-layout row v-if="notificationType === '2'">
        <v-flex xs12 lg8 md8>
          <p class="text-xs-left title">Варианты ответов</p>
          <v-card class="mx-0 mt-0 mb-4 elevation-1">
            <v-layout>
              <v-flex xs10 lg8 md8 class="ml-4 mt-4">
                <draggable v-model="notificationOptions" :options="{draggable:'.handle'}">
                  <div v-for="(option, key) in notificationOptions"
                      :key="key"
                       class="handle notification-options-input"
                  >
                    <v-text-field
                        :label="'Вариант ' + (key + 1)"
                        v-model="notificationOptions[key].title"
                        @input="onSetTextNotificationOptions(key)"
                        single-line
                        prepend-icon="drag_handle"
                        outline
                    ></v-text-field>
                  </div>
                </draggable>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 mt-3 mb-3">
        <v-flex xs12 lg12 md12>
          <p class="title">Дата и время рассылки</p>
          <v-date-picker
              v-model="sendDate"
              :reactive="true"
              locale="ru"
              class="mr-3 ml-0 mt-0 mb-3"
              :min="$moment().format('YYYY-MM-DD')"
              @input="checkValidate"
              :first-day-of-week="1"
          ></v-date-picker>

          <v-time-picker
              v-model="sendTime"
              format="24hr"
              class="mr-3 ml-0"
              :allowed-minutes="allowedStep"
              @input="checkValidate"
          ></v-time-picker>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6>
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickCreateNotification"
          >
            {{id === null ? 'Создать' : 'Изменить'}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    components: { draggable },
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Сообщения', link: '/notifications/future'}
      ],
      pageDataReady: {
        isReady: false,
        branchList: false,
        userGroupList: false
      },
      id: null,
      title: 'Новое сообщение',
      branch: null,
      branchId: null,
      saleGroup: null,
      saleGroupId: null,
      userGroup: null,
      userGroupId: null,
      notificationTitle: null,
      description: null,
      notificationType: '1',
      notificationOptions: [{id: 0, title: ''}],
      sendDate: null,
      sendTime: null,
      valid: false,
      notificationTitleRules: [
        v => !!v || 'Обязательное поле'
      ],
      descriptionRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.branchList) {
          return false
        }
        if (!this.pageDataReady.userGroupList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== undefined && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
        }
      },
      onSaleGroupSelect () {
        if (this.saleGroup !== null && this.saleGroup !== undefined && this.saleGroup !== 'Все супервайзеры') {
          for (let i = 0; i < this.saleGroupList.length; i++) {
            if (this.saleGroupList[i].title === this.saleGroup) {
              this.saleGroupId = this.saleGroupList[i].id
              break
            }
          }
        }
      },
      onUserGroupSelect () {
        if (this.userGroup !== null) {
          for (let i = 0; i < this.userGroupList.length; i++) {
            if (this.userGroupList[i].title === this.userGroup) {
              this.userGroupId = this.userGroupList[i].id
              break
            }
          }
        }
      },
      onSetTextNotificationOptions (key) {
        if (this.notificationOptions[key].title === '') {
          this.$delete(this.notificationOptions, key)
        } else if (this.notificationOptions.length - 1 === key) {
          this.notificationOptions.push({id: 0, title: ''})
        }
      },
      async onClickCreateNotification () {
        let notificationData = {
          id: this.id,
          notificationTitle: this.notificationTitle,
          description: this.description,
          type: this.notificationType,
          plannedSendDatetime: this.sendDate + ' ' + this.sendTime.substring(0, 2) + ':' + this.sendTime.substring(3, 5) + ':00'
        }

        if (this.branchId !== null) {
          notificationData.branchId = this.branchId
        }

        if (this.userGroupId !== null) {
          notificationData.userGroupId = this.userGroupId
        }

        if (this.saleGroupId !== null) {
          notificationData.saleGroupId = this.saleGroupId
        }

        if (this.notificationType === '2') {
          notificationData.notificationOptions = this.notificationOptions
        }

        await this.$store.dispatch('createNotification', notificationData)
          .then((data) => {
            if (typeof data.notification !== 'undefined') {
              this.$router.push('/notifications/single/' + data.notification.id)
            }
          })
          .catch(() => {})
      },
      allowedStep (val) {
        return val % 10 === 0
      },
      checkValidate () {
        if (this.sendDate === null) {
          this.valid = false
        } else if (this.sendTime === null) {
          this.valid = false
        } else if (this.notificationTitle === null || this.notificationTitle === '') {
          this.valid = false
        } else if (this.description === null) {
          this.valid = false
        } else {
          this.valid = true
        }
        return this.valid
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        this.id = null
        this.branch = null
        this.branchId = null
        this.saleGroup = null
        this.saleGroupId = null
        this.userGroup = null
        this.userGroupId = null
        this.notificationTitle = null
        this.description = null
        this.notificationType = '1'
        this.notificationOptions = [{id: 0, title: ''}]
        this.sendDate = null
        this.sendTime = null
        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Сообщения', link: '/notifications/future'}
        ]

        this.$store.dispatch('getBranchList')
          .then(() => {
            this.pageDataReady.branchList = true
            this.pageDataStatus()
          })

        this.$store.dispatch('getUserGroupList')
          .then(() => {
            this.pageDataReady.userGroupList = true
            this.pageDataStatus()
          })

        if (this.$router.currentRoute.path.indexOf('/notifications/edit/') !== -1) {
          this.id = parseInt(this.$route.params.id)
          this.title = 'Редактировать сообщение'
          this.breadcrumbs.push({name: 'Редактировать сообщение'})
          this.$store.dispatch('getNotificationSingle', {id: this.id})
        } else {
          this.id = null
          this.title = 'Новое сообщение'

          let date = new Date()
          date.setMinutes(date.getMinutes() + ((10 - date.getMinutes() % 10) + 10))
          this.sendDate = this.$moment(date).format('YYYY-MM-DD')
          this.sendTime = this.$moment(date).format('HH:mm')
          this.breadcrumbs.push({name: 'Новое сообщение'})
        }
        this.$store.commit('setPageTitle', this.title)
      }
    },
    computed: {
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      saleGroupTitleList () {
        return this.$store.getters.saleGroupTitleList
      },
      userGroupTitleList () {
        return this.$store.getters.userGroupTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      saleGroupList () {
        return this.$store.getters.saleGroupList
      },
      userGroupList () {
        return this.$store.getters.userGroupList
      },
      loading () {
        return this.$store.getters.loading
      },
      notification () {
        return this.$store.getters.notificationSingle
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      notification (newNotification, oldNotification) {
        if (this.notification !== null && this.notification !== undefined) {
          if (this.notification.branch !== null) {
            this.branch = this.notification.branch.title
            this.branchId = this.notification.branch.id
            this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
          } else {
            this.branch = null
            this.branchId = null
          }

          if (this.notification.sale_group !== null) {
            this.saleGroup = this.notification.sale_group.title
            this.saleGroupId = this.notification.sale_group.id
          } else {
            this.saleGroup = null
            this.saleGroupId = null
          }

          if (this.notification.user_group !== null) {
            this.userGroup = this.notification.user_group.title
            this.userGroupId = this.notification.user_group.id
          } else {
            this.userGroup = null
            this.userGroupId = null
          }

          this.notificationTitle = this.notification.title
          this.description = this.notification.description
          this.notificationType = this.notification.type.toString()

          if (this.notificationType === '2' && this.notificationOptions !== null) {
            this.notificationOptions = this.notification.notification_option_list
            this.notificationOptions.push({id: 0, title: ''})
          }

          this.sendDate = this.$moment(this.notification.planned_send_datetime).format('YYYY-MM-DD')
          this.sendTime = this.$moment(this.notification.planned_send_datetime).format('HH:mm')
        }
      },
      branchList (val) {
        if (this.$store.getters.user.branch !== null) {
          this.branch = this.$store.getters.user.branch.title
          this.branchId = this.$store.getters.user.branch.id
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
        }
        if (this.$store.getters.user.sale_group !== null) {
          this.saleGroup = this.$store.getters.user.sale_group.title
          this.saleGroupId = this.$store.getters.user.sale_group.id
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Notifications/NotificationNew.vue